import axios from 'axios';//引入axios
// 引入NProgress
import NProgress from 'nprogress'
// 引入nprogress样式文件
import'nprogress/nprogress.css'
import {
  Message,
} from 'element-ui'
import router from '../router'
import store from "../store/index";

let roupath = store.state
 axios.defaults.baseURL = 'https://erp.campgrounds.cn/'
// axios.defaults.baseURL = 'http://192.168.8.12/index.php/'
//  axios.defaults.baseURL = 'https://picnicpack.campgrounds.cn/index.php/'

// axios.defaults.baseURL = 'http://192.168.1.66:8081/'
// axios.defaults.timeout = 5000;//加载不出来5秒之后就是加载失败
axios.interceptors.request.use(config => {
    NProgress.start()
  if (!config.url.includes('login')) {  
    // console.log(window.sessionStorage.getItem("token"));
    config.headers['Accept-Token'] = window.sessionStorage.getItem("token")
    config.headers['Accept-Route'] = roupath.routeLink
  } return config
})
let isRedirecting = false
// 响应
axios.interceptors.response.use((response) => {
  if (response.data.code == 10001) {
    if (isRedirecting) return Promise.reject(new Error('token expired'))
    isRedirecting = true
    console.log("您的token已失效");
    Message({
      message: '您的token已失效',
      type: 'error',
    })
    window.sessionStorage.clear();
    router.push({ path: '/login' }).then(() => {
      isRedirecting = false
    })
    return Promise.reject(new Error('token expired'))
  }
  NProgress.done()
  return response

}, error => {
  // 在此定义请求错误需要做什么
  Message({
    message: '服务器错误',
    type: 'error',
  })

  return Promise.reject(error)
})

// 使用promise返回axios请求
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
};

// 后端为 ThinkPHP，仅解析表单格式参数，这里将普通对象序列化为 application/x-www-form-urlencoded
function toFormData(params, prefix, search) {
  Object.keys(params).forEach(key => {
    const value = params[key]
    const name = prefix ? `${prefix}[${key}]` : key
    if (value === null || value === undefined) {
      return
    }
    if (Array.isArray(value)) {
      value.forEach(item => {
        if (item !== null && typeof item === 'object') {
          toFormData(item, `${name}[]`, search)
        } else {
          search.append(`${name}[]`, item)
        }
      })
    } else if (typeof value === 'object' && !(value instanceof Date)) {
      toFormData(value, name, search)
    } else if (typeof value === 'boolean') {
      search.append(name, value ? 1 : 0)
    } else if (value instanceof Date) {
      search.append(name, value.toISOString())
    } else {
      search.append(name, value)
    }
  })
  return search
}

export function post(url, params) {
  let data = params
  if (params && typeof params === 'object' &&
      !(params instanceof FormData) &&
      !(params instanceof URLSearchParams) &&
      !(params instanceof Blob)) {
    data = toFormData(params, '', new URLSearchParams())
  }
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err.data)
    })

  })
}